import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { LoadingService } from '../loading.service';
import { LoadingImageHeader } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class LoadingInterceptor implements HttpInterceptor {
  private readonly loadingService = inject(LoadingService);

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    this.loadingService.startLoading({ loading: true, loadingImage: request.headers.get(LoadingImageHeader) ?? undefined });
    return next.handle(request).pipe(
      tap((res) => {
        if (res instanceof HttpResponse || res instanceof HttpErrorResponse) {
          this.loadingService.stopLoading({ loading: false });
        }
      }),
      catchError((err) => {
        this.loadingService.stopLoading({ loading: false });
        throw err;
      }),
    );
  }
}
